import { render, staticRenderFns } from "./ChildrenChecklist.vue?vue&type=template&id=65660a25"
import script from "./ChildrenChecklist.vue?vue&type=script&lang=js"
export * from "./ChildrenChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports